import { z } from 'zod';

import { AhqSubmissionCandidateExperienceSchema } from './ahq-submission-candidate-experience';
import { CandidateSchema } from './candidate';
import { CandidateReputationSchema } from './candidate-reputation';

export const AhqSubmissionCandidateSchema = CandidateSchema.pick({
  calculatedDisplayName: true,
  id: true,
}).extend({
  canDisplayReputationData: z.boolean(),
  candidateReputation: CandidateReputationSchema.nullable(),
  experiences: z.array(AhqSubmissionCandidateExperienceSchema).nullish(),
});

export type AhqSubmissionCandidate = z.infer<
  typeof AhqSubmissionCandidateSchema
>;
